<!-- Page Wrapper -->
<div id="wrapper">
  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">
    <!-- Main Content -->
    <div id="content">


      <!-- Begin Page Content -->
      <div class="container-fluid">
        <!-- Content Row -->
        <div class="row">
          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="row">
              <div class="col-md-9">
                <div class="card shadow py-1 mb-2">
                  <div class="card-body">
                    <p-select
                      [options]="periodos"
                      [(ngModel)]="selectedPeriodo"
                      optionLabel="nombre"
                      optionValue="id"
                      placeholder="Periodos"
                      class="w-100"
                      (ngModelChange)="onPeriodoChange()"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 pl-0">
                <div class="card shadow py-1 mb-2">
                  <div class="card-body d-flex justify-content-center">
                    <button class="btn btn-light" (click)="downloadReporteCz()">
                      <i class="bi bi-download"></i>
                    </button>

                  </div>
                </div>
              </div>
            </div>

            <app-card-value-pair
              title="Invitaciones"
              icon="bi bi-clipboard2"
              [value]="formattedInvitaciones"
              borderBottomColor="#cfcfcf"
              detailIcon="bi bi-list"
              [detailValue]="formattedLineasInvitaciones"
              tooltip1="Cantidad de invitaciones"
              tooltip2="Cantidad de líneas invitaciones"
              [isLoading]="isLoadingInvitaciones"
            ></app-card-value-pair>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="card shadow py-1 mb-2">
              <div class="card-body">
                <p-select
                  [options]="centrosGestion"
                  [(ngModel)]="selectedCentroGestion"
                  optionLabel="nombre_orgc"
                  optionValue="id_orgc"
                  placeholder="Centros de Gestión"
                  class="w-100"
                  [showClear]="true"
                  (ngModelChange)="onCentroGestionChange()"
                  [style.color]="'blue'"
                />
              </div>
            </div>

            <app-card-value-pair
              title="Proveedores invitados"
              icon="bi bi-people"
              [value]="formattedProveedoresInvitados"
              borderBottomColor="#cfcfcf"
              detailIcon="bi bi-clipboard2-data"
              [detailValue]="formattedOfertasProveedores"
              [isLoading]="isLoadingInvitaciones"
            ></app-card-value-pair>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="card shadow py-1 mb-2">
              <div class="card-body">
                <p-select
                  class="w-100"
                  [disabled]="true"
                />
              </div>
            </div>

            <!-- <app-card-circular-chart
              title="OC por Facturar"
              icon="bi bi-currency-dollar"
              value="280MM"
              borderBottomColor="#ff6b00"
              [chartValue]="72"
              chartProgressColor="##FF6B00"
            ></app-card-circular-chart> -->

            <app-card-value-pair
              title="Ofertas"
              icon="bi bi-clipboard2-data"
              [value]="formattedOfertas"
              borderBottomColor="#cfcfcf"
              detailIcon="bi bi-list"
              [detailValue]="formattedLineasOfertas"
              [isLoading]="isLoadingInvitaciones"
            ></app-card-value-pair>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="card shadow py-1 mb-2">
              <div class="card-body">
                <p-select
                  [options]="proveedores"
                  [(ngModel)]="selectedProveedor"
                  optionLabel="nombre_empresa"
                  optionValue="id_empresa"
                  placeholder="Proveedores"
                  class="w-100"
                  [showClear]="true"
                  (ngModelChange)="onProveedorChange()"
                />
              </div>
            </div>

            <app-card-value-pair
              title="Cotizaciones adjudicadas"
              icon="bi bi-check-circle"
              [value]="formattedCotizacionesAdjudicadas"
              borderBottomColor="#cfcfcf"
              detailIcon="bi bi-list-check"
              [detailValue]="formattedLineasAdjudicadas"
              [isLoading]="isLoadingInvitaciones"
            ></app-card-value-pair>
          </div>
        </div>

        <!-- Content Row -->

        <div class="row">
          <!-- Area Chart -->
          <div class="col-md-6">
            <app-card-barline-chart
              title="Cotizaciones"
              [labels]="labelsCzAdjudicadasMonthly"
              lineChartTitle="Prom Ofertas"
              [lineChartData]="ofertaPromomedioInvCzAdjudicadasMonthly"
              lineChartBorderColor="#ea721d"
              lineChart2Title="Prom Adju"
              [lineChart2Data]="ofertaPromomedioAdjCzAdjudicadasMonthly"
              lineChart2BorderColor="#ea721d"
              barChart1Title="Invitaciones"
              [barChart1Data]="cantidadTotalCzAdjudicadasMonthly"
              barChart1BorderColor="white"
              barChart1BackgroundColor="#f18b38"
              barChart2Title="Adjudicadas"
              [barChart2Data]="cantidadCantidadCzAdjudicadasMonthly"
              barChart2BorderColor="white"
              barChart2BackgroundColor="#ea721d"
              [isLoading]="isLoadingCotizacionesMonthly"
            ></app-card-barline-chart>
          </div>

          <!-- Pie Chart -->
          <div class="col-md-6">
            <app-card-barline-chart
              title="Invitados"
              [labels]="labelsCzAdjudicadasMonthly"
              lineChartTitle="% Invitados con oferta"
              [lineChartData]="porcentajeCzProveedoresMonthly"
              lineChartBorderColor="#ea721d"
              barChart1Title="Prov invitados"
              [barChart1Data]="provInvitadosCzProveedoresMonthly"
              barChart1BorderColor="white"
              barChart1BackgroundColor="#f18b38"
              barChart2Title="Prov con respuesta"
              [barChart2Data]="provRespuestaCzProveedoresMonthly"
              barChart2BorderColor="white"
              barChart2BackgroundColor="#f18b38"
              barChart3Title="Prov con adjudicaciones"
              [barChart3Data]="provAdjudicadosCzProveedoresMonthly"
              barChart3BorderColor="white"
              barChart3BackgroundColor="#ea721d"
              [isLoading]="isLoadingInvitadosMonthly"
            ></app-card-barline-chart>
          </div>
        </div>

        <!-- Content Row -->
        <div class="row">
          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-circular-chart
              title="OC origen cotizaciones"
              icon="bi bi-hash"
              [value]="formattedOrigenCotizacionesOc"
              borderBottomColor="#cfcfcf"
              [chartValue]="porcentajeCzOrigenOc"
              chartProgressColor="#FF6B00"
              [isLoading]="isLoadingOrigenCotizaciones"
            ></app-card-circular-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-circular-chart
              title="Montos OC origen cotizaciones"
              icon="bi bi-currency-dollar"
              [value]="formattedMontosOrigenCotizacionesOc + ' MM'"
              borderBottomColor="#cfcfcf"
              [chartValue]="porcentajeMontosOrigenOc"
              chartProgressColor="#FF6B00"
              tooltip1="Monto total de Cotizaciones cuyo origen es una OC"
              tooltip2="Porcentaje monto Cotizaciones cuyo origen es una OC respecto a total de OC"
              [isLoading]="isLoadingMontosOrigenCotizaciones"
            ></app-card-circular-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-circular-chart
              title="Plazo promedio apertura < 1 día"
              icon="bi bi-hourglass"
              [value]="formattedPromedioApertura"
              borderBottomColor="#cfcfcf"
              [chartValue]="porcentajeMenor"
              chartProgressColor="#FF6B00"
              [isLoading]="isLoadingPlazoPromedioApertura"
            ></app-card-circular-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-value-pair-ext
              title="Cierre anticipado"
              icon="bi bi-clipboard2"
              [value]="formattedPorcentajeCierreAnticipado"
              borderBottomColor="#cfcfcf"
              title2="Reabierta/Desierta"
              icon2="bi bi-file-earmark-excel"
              [isLoading]="isLoadingPorcentajeEstado"
              [value2]="formattedPorcentajeReabieraDesierta"
            ></app-card-value-pair-ext>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <footer class="sticky-footer bg-white">
      <div class="container my-auto">
        <div class="copyright text-center my-auto">
          <span>iConstruye 2024</span>
        </div>
      </div>
    </footer>
    <!-- End of Footer -->
  </div>
  <!-- End of Content Wrapper -->
</div>
<!-- End of Page Wrapper -->
